import { Box } from "@mui/material";
import UserForm from "../components/forms/userForm.component";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateUserStart } from "../store/features/user/userSlice";

const cleanUserData = (data) => {
  const cleaned = { ...data };

  ["legal_address", "administrative_address"].forEach((field) => {
    if (Object.values(cleaned[field] || {}).every((v) => v === "")) {
      delete cleaned[field];
    }
  });

  return cleaned;
};

const UpdateUserPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const access_token = useSelector((state) => state.auth?.user?.access_token);
  const users = useSelector((state) => state.users?.data?.data);
  const { isLoading, error, success } = useSelector((state) => state.user);

  const user = users?.find((u) => String(u.id) === String(id));

  const onSubmit = (data) => {
    const cleanedData = cleanUserData(data);
    dispatch(
      updateUserStart({
        data: cleanedData,
        accessToken: access_token,
        userId: id,
      })
    );
  };
  return (
    <Box width="100%" height="100%" overflow="auto">
      <UserForm
        mode="update"
        defaultValues={user}
        onSubmit={onSubmit}
        isLoading={isLoading}
        success={success}
        error={error}
        user={user}
        accessToken={access_token}
      />
    </Box>
  );
};

export default UpdateUserPage;
